import * as React from 'react';
import {
	makeStyles,
	Typography,
	Box,
	Card,
	CardContent,

	/*	CardActions, */
	Button,
	List,
	ListItem,
	Collapse,
} from '@material-ui/core';
import { IAskItems } from '../../types';
import { displayDateTime } from '../../util';
import { stores } from '../../store';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';

interface IProps {
	ask: IAskItems;
}
const useStyles = makeStyles(theme => ({
	root: {
		minWidth: 275,
	},
	actions: {
		justifyContent: 'flex-end',
	},
	nested: {
		height: '100%',
	},
	IconStyle: {
		background: theme.palette.warning.main,
		color: theme.palette.background.paper,
		borderRadius: '25px',
		justifyContent: 'space-between',
	},
	ArrowIcon: {
		fontSize: '2.5em',
		marginLeft: 'Auto',
		color: '#72879E',
		float: 'right',
	},
	closedCard: (props: IProps) => ({
		marginBottom: theme.spacing(2),
		boxShadow: 'none',
	}),
	actionIconButton: {
		width: 40,
		height: 40,
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		cursor: 'pointer',
		'&:hover': {
			backgroundColor: `${theme.palette.primary.main}0A`,
		},
	},
	ActionButtons: {
		backgroundColor: '#007DBA !important',
		color: '#FFFFFF',
		'&:hover': {
			color: '#FFFFFF',
		},
	},
}));

const AskEsme = (props: IProps) => {
	const classes = useStyles(props);
	const user = React.useContext(stores.context.user);
	const routes = React.useContext(stores.context.routes);
	const [jobOpen] = React.useState(true);
	const [decorateOpen, setDecorateJobOpen] = React.useState<any>({});
	const reqType = props.ask.RequestType;
	/***const jobHandleClick = () => {
		setJobOpen(!jobOpen);
	}; */
	const decorateHandleClick = (index: any) => {
		setDecorateJobOpen({ ...decorateOpen, [index]: !decorateOpen[index] });
	};
	return (
		<>
			{user.srFull &&
				user.srFull.map((n: any) => (
					<Card className={classes.closedCard}>
						<CardContent>
							<div style={{ width: '100%' }}>
								<Box>
									<Typography
										style={{ display: 'inline', fontSize: '24px', fontStyle: 'normal', fontWeight: 'normal' }}
										variant="h6"
										component="p"
										align="left"
									>
										{n.classstructure && n.classstructure[0].commodities[0].description}
									</Typography>
									<Typography
										style={{
											display: 'inline',
											float: 'right',
											fontSize: '24px',
											fontStyle: 'normal',
											fontWeight: 'normal',
										}}
										variant="h6"
										component="p"
										align="right"
									>
										{`Ref: ${n.ticketId}`}
									</Typography>
								</Box>
								<Box>
									<Typography
										style={{ display: 'inline', fontSize: '16px' }}
										align="left"
										variant="body2"
										color="textSecondary"
										component="p"
									>
										Address Details
									</Typography>
									<Typography
										style={{ display: 'inline', float: 'right', lineHeight: '1.4', fontSize: '16px' }}
										align="right"
										variant="subtitle2"
									>
										Service Request Status:
									</Typography>
								</Box>

								<div style={{ display: 'inline' }}>
									<div style={{ display: 'inline' }}>
										<Typography
											style={{ display: 'inline', fontSize: '16px' }}
											align="left"
											variant="body2"
											component="p"
											color="textSecondary"
										>
											{n.locationDescription}
										</Typography>
									</div>
									<div style={{ display: 'inline' }}>
										<Typography
											variant="subtitle2"
											style={{ display: 'inline', fontSize: '16px', float: 'right', lineHeight: '1.4' }}
											align="right"
											component="p"
										>
											{n.statusDescription}&nbsp;
											<span style={{ color: '#72879E', fontSize: '16px' }}>{displayDateTime(n.statusDate)}</span>
										</Typography>
									</div>
								</div>
							</div>
							<Box mt={1} textAlign="Right">
								{/* #gov plupcustomer maximo object changed & is a string now, info not available
								<Typography
									style={{ display: 'inline', fontSize: '16px', float: 'left' }}
									align="left"
									variant="body2"
									component="p"
									color="textSecondary"
								>
									{`Helpdesk phone ${n.pluspcustomer[0] && n.pluspcustomer[0].pelcusthdphone}`}
								</Typography>
								*/}
								<Box style={{ display: 'inline' }} justifyContent="right" display="flex" flexDirection="row" mt={1}>
									<Button
										title="Raise query"
										size="small"
										color="primary"
										aria-controls="simple-menu"
										variant="contained"
										aria-haspopup="true"
										className={classes.ActionButtons}
										onClick={() => {
											routes.navigate({
												name: 'chatbot',
												params: {
													srId: n.ticketId,
												},
											});
											const currentFeed = user.userSRs.find((f: any) => f.Id === props.ask.Id);
											currentFeed!.showOpenCard = false;
										}}
									>
										Raise query
									</Button>
								</Box>
								<Typography variant="body2">{'    '}</Typography>
								<Typography variant="subtitle1" style={{ textAlign: 'left', color: '#002855', fontSize: '18px' }}>
									Job History:
								</Typography>
							</Box>
							<Box mt={-2}>
								<List
									style={{
										marginTop: 20,
										background: '#F4F8FC',
										borderRadius: 5,
										marginBottom: 10,
									}}
								>
									{n.tkstatus &&
										n.tkstatus.map((statuses: any) => (
											<>
												<Card
													variant="outlined"
													style={{
														marginTop: '10px',
														borderRadius: 16,
														marginLeft: '10px',
														marginRight: '10px',

														boxShadow: '0px 3px 6px #00000029',
														opacity: '1',
													}}
												>
													<Box display="flex" flexDirection="row" mt={2} style={{ marginTop: 0 }}>
														<Typography variant="body2" style={{ padding: 15, color: '#002855', fontSize: '18px' }}>
															{statuses.statusDescription ? statuses.statusDescription : ''}
														</Typography>
														<Typography
															color="textSecondary"
															style={{ marginLeft: 'auto', padding: 15, color: '#002855', fontSize: '18px' }}
															variant="body2"
														>
															{statuses.changedate ? displayDateTime(statuses.changedate) : ''}
															{''}
														</Typography>
													</Box>
												</Card>
											</>
										))}
								</List>
								<Typography variant="body2">{'    '}</Typography>
								<Typography variant="subtitle1" style={{ textAlign: 'left', color: '#002855', fontSize: '18px' }}>
									Work Orders:
								</Typography>
							</Box>

							<Box mt={-2}>
								<List>
									<Collapse style={{ marginTop: '-20px' }} in={jobOpen} timeout="auto" unmountOnExit>
										{n.relatedRecord &&
											n.relatedRecord.length > 0 &&
											n.relatedRecord.map((workItems: any, index: any) => (
												<>
													<List
														style={{
															marginTop: '35px',
															background: '#F4F8FC',
															borderRadius: 5,
															marginBottom: 10,
														}}
													>
														<Card
															variant="outlined"
															style={{
																marginTop: '25px',
																borderRadius: 15,
																marginLeft: '10px',
																marginRight: '10px',
																background: ' #FFFFFF 0% 0% no-repeat padding-box',
																boxShadow: '0px 3px 6px #00000029',
																opacity: '1',
															}}
														>
															<ListItem button onClick={() => decorateHandleClick(index)}>
																<Typography variant="body2">{'    '}</Typography>
																<Typography variant="subtitle1" style={{ color: '#002855', fontSize: '18px' }}>
																	{workItems.workOrder[0].wonum} - {workItems.workOrder[0].description}
																</Typography>
																{decorateOpen[index] ? (
																	<ArrowDropDownIcon className={classes.ArrowIcon} />
																) : (
																	<ArrowRightIcon className={classes.ArrowIcon} />
																)}
															</ListItem>
															<Collapse
																style={{
																	background: 'white',
																	marginLeft: '15px',
																	marginRight: '15px',
																	overflowY: 'scroll',
																	height: '22vh',
																}}
																className={classes.nested}
																in={decorateOpen[index]}
																timeout="auto"
																unmountOnExit
															>
																{reqType == 'Esme' &&
																	workItems.workOrder[0].assignmenthistory &&
																	workItems.workOrder[0].assignmenthistory.map((history: any) => (
																		<>
																			<Box display="flex" flexDirection="row" mt={2}>
																				<Typography variant="body2">
																					{history.statusDescription ? history.statusDescription : ''}
																				</Typography>
																				<Typography
																					color="textSecondary"
																					style={{ marginLeft: 'auto' }}
																					variant="body2"
																				>
																					{/* {displayDateTime(n.relatedRecord[0].workOrder[0].assignment.finishDate)} */}
																					{history.statusdate ? displayDateTime(history.statusdate) : ''}
																					{''}
																				</Typography>
																			</Box>
																			<Box my={1}></Box>
																		</>
																	))}
																{workItems.workOrder[0].mitcahistory &&
																	workItems.workOrder[0].mitcahistory.map((history: any) => (
																		<>
																			<Box display="flex" flexDirection="row" mt={2}>
																				<Typography variant="body2">
																					{history.mitcastatus ? ' ' + history.mitcastatus : ''} -
																					{history.mitcareason ? ' ' + history.mitcareason : ''}
																				</Typography>
																				<Typography
																					color="textSecondary"
																					style={{ marginLeft: 'auto' }}
																					variant="body2"
																				>
																					{/* {displayDateTime(n.relatedRecord[0].workOrder[0].assignment.finishDate)} */}
																					{history.changedate ? displayDateTime(history.changedate) : ''}
																					{''}
																				</Typography>
																			</Box>
																			<Box my={1}></Box>
																		</>
																	))}
															</Collapse>
														</Card>
													</List>
												</>
											))}
									</Collapse>
								</List>
							</Box>
						</CardContent>
						{/* <CardActions className={classes.actions}>
							<Button
								size="small"
								color="primary"
								aria-controls="simple-menu"
								aria-haspopup="true"
								onClick={() => {
									const currentFeed = user.userSRs.find((f: any) => f.Id === props.ask.Id);
									currentFeed!.showOpenCard = false;
								}}
							>
								Close
							</Button>
							<Button
								size="small"
								color="primary"
								aria-controls="simple-menu"
								aria-haspopup="true"
								onClick={() => {
									routes.navigate({
										name: 'chatbot',
										params: {
											srId: n.ticketId,
										},
									});
									const currentFeed = user.userSRs.find((f: any) => f.Id === props.ask.Id);
									currentFeed!.showOpenCard = false;
								}}
							>
								Raise query
							</Button>
						</CardActions> */}
					</Card>
				))}
		</>
	);
};

export default AskEsme;
